import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Stack } from '@mui/material'

import { FORGOT_PASSWORD_PROFILE_DISPATCH } from 'src/store/reducers/auth/forgotPassword'
import { LOG_IN_URL } from 'src/constants/navigation'
import customConfig from 'customConfig'
import CustomForm from 'src/components/shared/inputs/CustomForm'
import CustomTextField from 'src/components/shared/inputs/CustomTextField'
import SubmitButton from 'src/components/shared/button/SubmitButton'
import { FormReturnLink } from 'src/components/shared/auth/form-return-link'
import Text from 'src/components/shared/text/Text'
import { FormHead } from 'src/components/shared/auth/form-head'
import PageTitle from 'src/components/shared/pageTitle/PageTitle'

const ForgotPassword = ({
  onFormSubmit,
  dispatchAction,
  forgotPasswordProfile: { error, success, email }
}) => {
  const { t } = useTranslation()
  const pageTitle = t('forgot-password.forgot-password')
  return (
    <>
      <PageTitle title={pageTitle} />
      <FormHead
        title={
          <Stack spacing={1}>
            <Text label={t(customConfig.forgotPasswordLabel)} />
            <Text label={t(customConfig.signWithSocialLabel)} />
            <Text label={t('forgot-password.account-not-verified-note')} />
          </Stack>
        }
        sx={{ textAlign: { xs: 'center', md: 'left' } }}
      />
      <CustomForm onFormSubmit={onFormSubmit}>
        <Box sx={{ gap: 3, display: 'flex', flexDirection: 'column' }}>
          <CustomTextField
            type='email'
            label={t('common.email-address')}
            error={t(error[FORGOT_PASSWORD_PROFILE_DISPATCH.EMAIL])}
            success={t(success[FORGOT_PASSWORD_PROFILE_DISPATCH.EMAIL])}
            value={email}
            onChange={(value) =>
              dispatchAction(FORGOT_PASSWORD_PROFILE_DISPATCH.EMAIL, value)
            }
          />
          <SubmitButton label={t('forgot-password.send-link')} />
        </Box>
      </CustomForm>
      <FormReturnLink label={t('common.cancel')} to={LOG_IN_URL} />
    </>
  )
}

export default memo(ForgotPassword)
